<template>
	<div class="offer-detail-popup">
		<component
			:is="detailComponent"
			:contentData="contentData"
			@closePopup="$emit('closePopup', $event)"
		/>
		<div class="offer-detail-popup__decoration">
			<GoldenCorner bottom left />
			<GoldenCorner bottom right />
		</div>
	</div>
</template>

<script lang="ts" setup>
import BundleOfferDetail from "@/components/shop/templates/BundleOfferDetail.vue";
import EventPassOfferDetail from "@/components/shop/templates/EventPassOfferDetail.vue";
import FourSlotOfferDetail from "@/components/shop/templates/FourSlotOfferDetail.vue";
import OneSlotOfferDetail from "@/components/shop/templates/OneSlotOfferDetail.vue";
import PiggyBankOfferDetail from "@/components/shop/templates/PiggyBankOfferDetail.vue";
import RoyalProvisionOfferDetail from "@/components/shop/templates/RoyalProvisionOfferDetail.vue";
import ThreeSlotOfferDetail from "@/components/shop/templates/ThreeSlotOfferDetail.vue";
import TwoSlotOfferDetail from "@/components/shop/templates/TwoSlotOfferDetail.vue";
import GoldenCorner from "@/components/SVG/GoldenCorner.vue";
import { OfferTemplate, type ShopItem } from "@/types/shop";
import type { Component } from "vue";
import { computed } from "vue";

interface Props {
	contentData: ShopItem;
}
const { contentData } = defineProps<Props>();

const detailComponent = computed((): Component => {
	const template = contentData.attributes.template;

	switch (template) {
		case OfferTemplate.SLOTS_1:
			return OneSlotOfferDetail;
		case OfferTemplate.SLOTS_2:
			return TwoSlotOfferDetail;
		case OfferTemplate.SLOTS_3:
			return ThreeSlotOfferDetail;
		case OfferTemplate.SLOTS_4:
			return FourSlotOfferDetail;
		case OfferTemplate.PIGGY_BANK:
			return PiggyBankOfferDetail;
		case OfferTemplate.BUNDLE:
			return BundleOfferDetail;
		case OfferTemplate.EVENT_PASS:
			return EventPassOfferDetail;
		case OfferTemplate.PROVISION:
			return RoyalProvisionOfferDetail;
		default:
			return OneSlotOfferDetail;
	}
});
</script>

<style lang="scss" scoped>
.offer-detail-popup {
	position: relative;
	border-radius: 0.15rem;
	background: linear-gradient(
		0deg,
		rgba(216, 169, 114, 1) 0%,
		rgba(226, 181, 145, 1) 50%,
		rgba(175, 146, 109, 1) 100%
	);
	padding: 0.125rem;
	width: 100%;
	@include flex-col-start;

	.template-layout {
		width: 100%;
		@include flex-col-start;
	}

	&__decoration {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 3;
		width: 100%;
		height: 100%;
		pointer-events: none;

		:deep(.golden-corner) {
			width: 1.5rem;
			height: 1.5rem;
		}

		:deep(.golden-corner--bottom-left) {
			position: absolute;
			bottom: 0;
			left: 0;
		}

		:deep(.golden-corner--bottom-right) {
			position: absolute;
			right: 0;
			bottom: 0;
		}
	}
}
</style>
